import React, { ReactNode } from 'react';
import { Dialog } from '@mui/material';

export interface SiteDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  dialogChildren: ReactNode
}

const SiteDialog: React.FC<SiteDialogProps> = ({ open, setOpen, dialogChildren }) => {

  const handleClose = () => {
    setOpen(false)  
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      { dialogChildren }
    </Dialog>
  );
};

export default SiteDialog;
